if (!customElements.get("prop-input")) {
	customElements.define(
		"prop-input",
		class PropInput extends HTMLElement {
			constructor() {
				super()

				var product_form_id = `#product-form-${this.dataset.sectionId}`
				this.productForm = document.querySelector(product_form_id)

				if (!this.productForm) return

				//create property input
				var hidden = JSON.parse(this.dataset.hidden)
				var name = (hidden ? "_" : "") + this.dataset.name
				this.form_input = document.createElement("input") //keeps reference when used later
				this.form_input.type = "hidden"
				this.form_input.name = `properties[${name}]`

				this.productForm.appendChild(this.form_input)

				this.addEventListener("input", (e) => this.handleInput(e))
			}
			handleInput = (e) => {
				var input = e.target //this can be input or textarea

				var value = input.value

				this.form_input.value = value
			}
		}
	)
}
